module.exports = __webpack_public_path__ + "static/microsoft-sql-server-logo-1bf1a2e0b716e3b1b60f4e5731549631.png";